<!--
 * @Author: 刘锦
 * @Date: 2020-09-18 11:55:30
 * @LastEditTime: 2021-07-29 16:25:17
 * @LastEditors: Seven
 * @Description: 
 * @FilePath: \workbench-front\src\components\order\order-modal.vue
-->
<template>
<el-drawer :visible.sync="visible" size="90%" title="扣费项目">
  <div class="drawer-container">
      <div class="drawer-content">
        <div class="drawer-body">
          <div class="goods-form-wrapper">
            <!-- 搜索表单区 -->
            <el-row :gutter="24" style="padding-top: 10px">
              <el-form class="formContent" :model="orderModalFields" :rules="orderModalRules" label-position="right" label-width="120px" inline>
                <el-col :span="6" 
                  v-for="item of orderModalItems"
                  :key="item.label">
                  <el-form-item
                    class="searchItem"
                    :style="item.itemStyle"
                    :prop="item.prop"
                  >
                    <!-- <el-select class="itemType" clearable v-model="orderModalFields[item.prop]" placeholder="请选择" v-if="item.type === 'select'">
                      <el-option v-for="(option, key) of item.options" :key="key" :label="option.label" :value="option.value" />
                    </el-select> -->
                    <v-autocomplete
                      v-if="item.type === 'select'"
                      v-model="orderModalFields[item.prop]"
                      :items="item.options"
                      :label="item.label"
                      :menu-props="{ bottom: true, offsetY: true }"
                      item-text="label"
                      item-value="value"
                      outlined
                      :dense="true"
                      :height="32"
                      :clearable="true"
                      clear-icon="$clear"
                      hide-details="auto"
                      no-data-text="暂无数据"
                    ></v-autocomplete>
                    <!-- <el-input
                      v-else
                      class="normal-input"
                      style="width:162px;"
                      clearable
                      v-model="orderModalFields[item.prop]"
                      :disabled="item.disabled"
                      :placeholder="item.placeholder"
                      :suffix-icon="item.suffixIcon"
                    /> -->
                    <v-text-field
                      v-else
                      hide-details="auto"
                      v-model="orderModalFields[item.prop]"
                      :label="item.label"
                      :disabled="item.disabled"
                      outlined
                      :dense="true"
                      :height="32"
                    ></v-text-field>
                  </el-form-item>
                </el-col>
              <div style="width: 100%;padding-left: 12px">
                <el-button type="primary" @click="onSearch">查询</el-button>
                <el-button @click="onReset">重置</el-button>
              </div>
            </el-form>
            </el-row>
          </div>
          <div class="seledItem">已选项目：{{seledReceiveData.length}}</div>
          <!-- 收支项目表格区 -->
          <div class="goods-table-wrapper">
            <el-table
              :data="tableData"
              style="width: 100%;"
              border
              stripe
              size="mini"
              element-loading-text="拼命加载中"
              :header-cell-style="{ background: '#e5f2ff' }"
              height="500px"
              ref="multipleTable"
              :row-key="getRowKeys"
              :expand-row-keys="expandRowKeys"
              @select-all="selectAll"
              @selection-change="onSelectChange"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            >

            <!-- <el-table-column :show-overflow-tooltip="true" label="选择"    type="">
                <template v-slot:default="{ $index, row }">
                  <el-checkbox
                  v-show="row.children == null"
                    @change.native="onRadioChange($index, row)"
                  ></el-checkbox>
                </template>
              </el-table-column> 
                <el-table-column :show-overflow-tooltip="true" type="selection"  slot-scope="scope" v-if="!scope.row.type || scope.row.type == null"></el-table-column>  
              <el-table-column :show-overflow-tooltip="true" type="selection" v-if="!checkStatus && checkStatus != 1"></el-table-column> -->

              <el-table-column :show-overflow-tooltip="true" type="selection"  :selectable="selectable" ></el-table-column> 
              <template v-for="item of columns">
                <el-table-column :show-overflow-tooltip="true" v-if="item.prop === 'updateTime'" :key="item.prop" :label="item.label" :min-width="item.width || '160px'">
                  <template v-slot:default="{ row }">
                    {{ row.updateTime  }}
                  </template>
                </el-table-column>
                  <el-table-column :show-overflow-tooltip="true"
                    v-else
                    :type="item.type"
                    :key="item.label"
                    :label="item.label"
                    :prop="item.prop"
                    :fixed="item.fixed"
                    :min-width="item.width || '160px'"
                  />
              </template>
            </el-table>
          </div>
        </div>
        <div class="drawer-footer">
          <el-button @click="onCancel">返回</el-button>
          <el-button type="primary" @click="onOk" :disabled="isCurrentRow">确定</el-button>
        </div>
      </div>
  </div>
  </el-drawer>
</template>

<script>
import { orderStatusMap } from '../constants'
export default {
  name: "OrderModal",
  props: {
    visible: Boolean,
    aftersaleType: [Number, String],
    orderModalFields: Object,
    orderModalRules: Object,
    orderModalItems: Array,
    dropOutTableList: Array,
    // selectMode 0 单选 1 多选
    selectMode: String,
    receiveSelItem:Array,
    currentSelDrop:Array,//当前选中表格的收支项目
  },
  
  data() {
    return {
      expandRowKeys:[],
      isAllSelect:false,
      currentRadioIndex: "",
      tableData:[],
      isCurrentRow:true,
      seledReceiveData:[],//已选择收支项目类目
      columns: [
        // { label: "选中", prop: "selection",  type:"selection" },
        { label: "收支项目ID", prop: "id", width: "200px", type:"" },
        { label: "NC收支项目编码", prop: "code",  type:""  },
        { label: "NC收支项目名称", prop: "name",width: "300px", },
        { label: "NC收支项目类型", prop: "type",  },
        { label: "更新时间", prop: "updateTime" },
      ],
      page: 1,
      pageSize: 10,
      totalPage: 1,
      totalCount: 1,
      goodsCateModalVisible: false,
      currentRow: {},
      selectRows: [],
      orderStatusMap,
      checkedKeys: [], //默认选中的数组
    }
  },
  methods: {
    selectInit(row,index){
      if(row.status==2){
          return false  //不可勾选
      }else{    
          return true  //可勾选
      }
    },
    onSelectChange() {
      let sel = this.$refs.multipleTable.selection;
      this.isCurrentRow=  sel.length >0 ? false:true
      this.seledReceiveData = sel
      // console.log("所有选中的值",sel)
    },

    //已选择的收支项目设置禁选
    checkSeled(row){
      let index = this.currentSelDrop.findIndex(item => item.inoutProjectId == row.inoutProjectId)
      if( index >= 0){
        return true
      }
      return false
    },
    selectable(row, index) { //是否可选收支项目  
      let status = this.checkSeled(row);
      if(row.children == null && !status){
        return true
      }else {
        return false
      }
    },
    checked(row,index){//是否自动选中

    },
    selectAll(selection, first) {
      if (!first) {
          this.isAllSelect = !this.isAllSelect;
      }
      selection.map(el => {
          if (el.children) {
              el.children.map(j => {
                  this.toggleSelection(j, this.isAllSelect);
              });
              if (el.children.length > 0) {
                  this.selectAll(el.children, true);
              }
          }
      });
    },
    toggleSelection(row, select) {
        if (select) {
        this.$nextTick(() => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        })
        // this.$refs.multipleTable.toggleRowSelection(row, select);
        } else {
            this.$refs.multipleTable.clearSelection();
        }
    },
    findSeled(){
      let sel = this.$refs.multipleTable.selection;
      console.log("所有选中的值",sel)
    },
    getRowKeys(row) {
      //修复增添收支项id被删除问题 
      return row.id || row.inoutProjectId;
    },
    onCancel() {
      this.$emit("on-cancel")
    },
    onOk() {
      if (this.selectMode == "0") {
        console.log("单选")
        // const row = JSON.parse(JSON.stringify(this.currentRow))
        // this.$emit("on-ok", row)
      } else {
        // const rows = JSON.parse(JSON.stringify(this.selectRows))
        // this.$emit("on-ok", rows)
        this.$emit("on-ok",  this.seledReceiveData)
      }
    },
    // 查询
    onSearch() {
      this.getTableDataset()
    },
    // 重置
    onReset() {
      Object.keys(this.orderModalFields).forEach(key => (this.orderModalFields[key] = ""))
      this.getTableData()
    },
    // 获取订单列表表格数据
    async getTableDataset() {
      const params = {
        ...this.orderModalFields,
      }

      console.log("表格的参数",params);

      const { data, code } = await this.$fetch("inoutProjectFindquery", params)
      this.tableData = data
      this.setSeledDropOut(this.tableData)
    //   let tmp = this.tableData[0]
    //   console.log("自动选中收支项目tmp",tmp)
    //  this.$nextTick(() => {
    //   this.$refs.multipleTable.toggleRowSelection(tmp, true);

    //  })
      // console.log(this.$refs.multipleTable.toggleRowSelection)

    //   this.tableData = data.records.map(item => ({ ...item, checked: false }))
    //   this.totalPage = data.pages
    //   this.totalCount = data.total
    },
    onRadioChange(index, row) {
      this.currentRadioIndex = index
      this.currentRow = row
    },
    selOrder(row){
      this.currentRow = row
    },

    pageChange() {
      this.currentRadioIndex = ""
      this.getTableData()
    },
    pageSizeChange() {
      this.currentRadioIndex = ""
      this.page = 1
      this.getTableData()
    },
    // 商品分类弹窗取消回调
    onGoodsCateCancel() {
      this.goodsCateModalVisible = false
    },
    setSeledDropOut(data){

      // console.log("已选中的收支项目",this.currentSelDrop)
      // let tmp = this.tableData[0].children[1]
      // console.log("自动选中收支项目",tmp)
      // this.$nextTick(() => {
      //       this.$refs.multipleTable.toggleRowSelection(tmp, true);
      //       })
      for(let i in data){
        if(data[i].children){
          this.setSeledDropOut(data[i].children)
        }else if(this.currentSelDrop.findIndex(item => item.inoutProjectId == data[i].inoutProjectId) >=0){
          console.log("自动选中",data[i])
          this.toggleSelection(data[i],true)
          this.seledReceiveData.push(data[i])
        }
      }
    },
    // 获取订单列表表格数据
    async getTableData() {
      const params = {
        ...this.orderModalFields,
      }

      const { data, code } = await this.$fetch("inoutProjectFindAll", params)
      this.tableData = data
      this.setSeledDropOut(this.tableData)
      return
      // 默认选中已选的扣费项目
      this.dropOutTableList[0].forEach( val => {
          this.checkedKeys.push(val.inoutProjectId)
          this.expandRowKeys.push(val.inoutProjectId)
          if(val.parentId) this.expandRowKeys.push(val.parentId)
      })
      this.$nextTick( ()=> {
        this.checked(this.tableData)
      })
    //   this.tableData = data.records.map(item => ({ ...item, checked: false }))
    //   this.totalPage = data.pages
    //   this.totalCount = data.total
    },
    checked(array) {
      array.forEach( item => {
        if(this.checkedKeys.indexOf(item.id) != -1) {
          this.$refs.multipleTable.toggleRowSelection(item, true);
        }
        if(item.children && item.children.length > 0) {
          this.checked(item.children)
        }
      })
    },
  },

  // computed: {
  //   isCurrentRow() {
  //     if (!this.currentRow) return false
  //     return !!Object.keys(this.currentRow).length || !!this.selectRows.length
  //   }
  // },
  watch: {
    visible: {
      handler(visible) {
        if (!visible) return
        this.getTableData()
      }
    }
  }
}
</script>

<style lang="scss">
.seledItem{
  text-align: right;
  padding-right:30px;
  font-size: 16px;
  color: #333;
}
 .myCell .el-checkbox__input {
  display: none
}
.drawer-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 100;
  background: rgba($color: #000000, $alpha: 0.6);
  .drawer-container {
    // position: relative;
    // left: 0;
    // right: 0;
    // top: 0;
    // bottom: 0;
    height: 100%;
    width: 94%;
    margin: 0 auto;
    .drawer-content {
      position: absolute;
      right: 0;
      top: 0;
      display: flex;
      flex-direction: column;
      width: 72%;
      height: 100%;
      background: #fff;
      box-shadow: -6px 0px 10px 0px rgba(112, 112, 112, 0.12);
      .drawer-header {
        display: flex;
        width: 100%;
        height: 60px;
        line-height: 60px;
        padding: 0 30px;

        > h2 {
          color: #333;
          font-size: 16px;
          font-weight: 700;
        }
      }
      .drawer-body {
        flex: 1;
        border-top: 1px solid #e1e4eb;
        border-bottom: 1px solid #e1e4eb;
        overflow: auto;
        .goods-form-wrapper {
          margin: 30px 0 0px 0;
          padding: 0 25px;
          .formContent{
            display: flex;
            flex-wrap: wrap;
          }
          .searchItem{
            // display: flex;
            // width: 300px;
            width: 100%;
          }
          ::v-deep .el-input__suffix {
            right: 12px;
          }
        }
        .actions-btn {
          padding-left: 68px;
        }
        .goods-table-wrapper {
          width: 100%;
          margin-bottom: 44px;
          padding: 0 30px;
          .el-radio__label{
            display: none;
          }
        }
      }
      .drawer-footer {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 90px;
      }
    }
  }
}
.drawer-enter-active,
.drawer-leave-active {
  transition: 0.3s;
}
.drawer-enter {
  transform: translate(100%);
}
.drawer-leave-to {
  transform: translate(100%);
}
.itemType{
  width: 160px;
}



.drawer-body {
  width: 94%;
  margin: 0 auto;
  .goods-form-wrapper {
    .formContent {
      display: flex;
      flex-wrap: wrap;
    }
    .searchItem {
      // display: flex;
      // width: 300px;
      width: 100%;

      .el-form-item__content {
        width: 100%;
      }
    }
    ::v-deep .el-input__suffix {
      right: 12px;
    }
  }
  .actions-btn {
    padding-left: 68px;
  }
  .goods-table-wrapper {
    // width: 100%;
    margin-top: 10px;
    .el-radio__label {
      display: none;
    }
  }
}

.drawer-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 90px;
}
     

.drawer-enter-active,
.drawer-leave-active {
  transition: 0.3s;
}
.drawer-enter {
  transform: translate(100%);
}
.drawer-leave-to {
  transform: translate(100%);
}
::v-deep .el-form-item__label {
  text-align: left !important;
}

</style>
